import React from "react";
import styled from "styled-components";
import {
  FlexibleContainer,
  RowContainer,
} from "../containers/styledComponents";
import { greyText, lightGreys } from "../../styles";
import { CompassParagraph } from "../common/styledComponents";
import { DataEntry } from "../../models/stewardshipModels";

export const HeaderRow = styled(RowContainer)`
  justify-content: space-between;
  padding-bottom: 7px;
  border-bottom: 1px solid ${lightGreys.borderLightGrey};
`;

const DataEntryRow = styled(RowContainer)<{ isCountryLabel?: boolean }>`
  align-items: center;
  justify-content: space-between;
  padding-bottom: 4px;
  border-bottom: 1px solid ${lightGreys.borderLightGrey};
`;

const TableColumn = styled.div`
  width: 50%;
`;

type Column = {
  title: string;
};

export const KeyValueTable: React.FC<{
  columns: Column[];
  data: DataEntry[];
}> = ({ columns, data }) => {
  return (
    <FlexibleContainer fd="column" w={"100%"} p={"10px 5px"} ofy="auto">
      <HeaderRow>
        <CompassParagraph color={greyText} bold={true} style={{ width: "50%" }}>
          {columns[0].title}
        </CompassParagraph>
        <CompassParagraph color={greyText} bold={true} style={{ width: "50%" }}>
          {columns[1].title}
        </CompassParagraph>
      </HeaderRow>
      {data.map((entry, index) => (
        <DataEntryRow key={index}>
          <TableColumn>
            <CompassParagraph fontSize={12}>{entry.label}</CompassParagraph>
          </TableColumn>
          <TableColumn>
            {React.isValidElement(entry.value) ? (
              entry.value
            ) : (
              <CompassParagraph fontSize={12}>
                {entry.value.toString()}
              </CompassParagraph>
            )}
          </TableColumn>
        </DataEntryRow>
      ))}
    </FlexibleContainer>
  );
};
